export default "__VITE_ASSET__CGAUpXhj__"